function gopherInstalled() {
  return !!document.querySelector("#gopher-installed");
}

function mobileBannerPresent() {
  return !!document.querySelector("#mobile_banner_container");
}

export function initBanner() {
  $(function () {
    const extensionInstalled = gopherInstalled();
    const shouldShowBanner = mobileBannerPresent();
    const whichBanner = sessionStorage.getItem("whichBanner");

    $("#closeMobileButton, #smCloseMobileButton").on("click", function () {
      // Hide the banner
      $("#mobile_banner_container").hide();
      // Set a session storage variable to remember that the banner is hidden for the session
      sessionStorage.setItem("hideMobileBanner", "true");
    });

    if (!shouldShowBanner) {
      return;
    }

    if (sessionStorage.getItem("hideMobileBanner") === "true") {
      $("#mobile_banner_container").hide();
      return;
    }

    // save which banner to show via sessionStorage
    if (whichBanner) {
      console.log(whichBanner);
      if (whichBanner === "mobile_banner") {
        $("#mobile_banner_container").show();
        $("#extension_banner").hide();
      } else {
        $("#mobile_banner_container").hide();
        $("#extension_banner").show();
      }
      return;
    }

    // if extension is installed
    if (extensionInstalled) {
      $("#mobile_banner_container").show();
    } else {
      // extension not installed randomize mobile/extesion banner
      const randomNumber = Math.round(Math.random());

      if (randomNumber === 1) {
        $("#mobile_banner_container").show();
        $("#extension_banner").hide();
        sessionStorage.setItem("whichBanner", "mobile_banner");
      } else {
        $("#mobile_banner_container").hide();
        $("#extension_banner").show();
        sessionStorage.setItem("whichBanner", "extension_banner");
      }
    }
  });
}
